import { useAppendDraftComment } from 'pages/WellGuardian/WIR/hooks';
import { getActivePhaseIsReactiveScope } from 'pages/WellGuardian/WIR/utils';
import { Phase, Section, WIRCreateJourneyStepsKeys } from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback } from 'react';
import { useCountryState, useSelectedWIR } from '../../../../redux/WellGuardian/selectors';
import { WIRPhaseTypes } from 'types/wellGuardian';

export const useSectionData = () => {
  const wirFromState = useSelectedWIR();
  const { appendDraftComment } = useAppendDraftComment();
  const countryState = useCountryState();

  const getSectionPayload = useCallback(
    (phase: string, section: string, phaseForApi: string, sectionForApi: string) => {
      const phaseUpdated = getActivePhaseIsReactiveScope(wirFromState, phase as Phase, countryState)
        ? WIRCreateJourneyStepsKeys.REACTIVE_SCOPE
        : phase;
      const comments = appendDraftComment(
        wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.comments ||
          [],
      );
      const attachments =
        wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]
          ?.attachments || [];
      const isRequired =
        wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.isRequired;
      const reason =
        wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.reason;

      const isCriticalSensitiveJob =
        wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]
          ?.isCriticalSensitiveJob;

      return {
        comments,
        attachments,
        isRequired,
        reason,
        isCriticalSensitiveJob,
        afeGhg:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.afeGhg ||
          '0',
        afeEmission:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]
            ?.afeEmission || '0',
        attendees:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.attendees,
        phase: getActivePhaseIsReactiveScope(wirFromState, phase as Phase, countryState)
          ? WIRPhaseTypes.REACTIVE_SCOPE
          : phaseForApi,
        section: sectionForApi,
        lastUpdatedDate: new Date().toISOString(),
        assignedTo:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]
            ?.assignedTo || '',
        isVisible:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.isVisible,
        sectionCompleteConfirmation:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]
            ?.sectionCompleteConfirmation,
        user_selection:
          wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[
            section as Section
          ]?.isRequired?.toString(),
        wonsReference: wirFromState?.phases?.[phaseUpdated as Phase]?.sections?.[section as Section]?.wonsReference,
      };
    },
    [wirFromState, appendDraftComment, countryState],
  );

  return {
    getSectionPayload,
  };
};
